export const FIRM_DOCUMENT_FILE_ACTIONS_LABELS = {
  copy: 'Copy to Another Measurement Date',
  delete: 'Delete',
  download: 'Download',
  rename: 'Edit',
  trigger: (fileName: string) => `${fileName} actions`,
} as const;
